export enum OrderStatus {
  Created = 1,
  ToShip = 2,
  ToReceive = 3,
  Completed = 4,
  Canceled = 5,
  Refunded = 6,
  Deleted = 7,
}

export enum OrderTypeEnum {
  POINTS = 1,
  POINTS_BOX,
  POINTS_WORD,
  PHYSICAL_OBJECT,
  COINS_WORD,
  COINS,
  SUPS,
  SUPS_WORD,
}

export const OrderTypeMap = new Map([
  [OrderTypeEnum.POINTS, '积分商品订单'],
  [OrderTypeEnum.POINTS_BOX, '积分盲盒订单'],
  [OrderTypeEnum.POINTS_WORD, '积分提示词订单'],
  [OrderTypeEnum.PHYSICAL_OBJECT, '积分实物订单'],
  [OrderTypeEnum.COINS_WORD, '充值金币提示词订单'],
  [OrderTypeEnum.COINS, '充值金币商品订单'],
  [OrderTypeEnum.SUPS, '活动金币商品订单'],
  [OrderTypeEnum.SUPS_WORD, '活动金币提示词订单'],
]);

export interface OrderListParams {
  orderId?: string;
  productTitle?: string;
  userNumber?: string;
  userName?: string;
  orderStatus?: number;
  productCategoryId?: number;
  sourceType?: number; // 用户来源：1-suppart，2-appleId，3-facebook，4-googleId，5-LineId
  currentPage: number;
  pageSize: number;
}

export interface OrderListResponse {
  total: number;
  currentPage: number;
  pageSize: number;
  records: OrderItem[];
}

export interface OrderItem {
  orderId: string;
  userId?: string; // 兼容旧字段
  userNumber?: string; // SUPP ID
  userName: string;
  orderType: number;
  categoryId: string;
  points: number;
  productInfoId: string;
  productTitle: string;
  productShowImage: string;
  productCount: number;
  orderStatus: number;
  sumPoints: number;
  createTime: string;
  payTime?: string;
  registerTime?: string; // 注册时间
  afSource?: string; // appsflyer渠道来源
  afCampaign?: string; // appsflyer归因数据
  deviceType?: number; // 注册端(user_info.device_type)：1-iOS App，2-Android App，3-iOS H5，4-Android H5，5-PC Web
}

export interface OrderDetail extends OrderItem {
  productImage: string;
  fullName?: string; // 收货人姓名
  phoneNumber?: string; // 电话
  email?: string; // 邮箱
}

export interface RechargeOrderListParams {
  suppId?: string;
  transactionId?: string;
  status?: number;
  sourceType?: number; // 用户来源：1-suppart，2-appleId，3-facebook，4-googleId，5-LineId
  vipName?: string; // 用户身份
  createTime?: Array<any>;
  createTimeStart?: number;
  createTimeEnd?: number;
  currentPage: number;
  pageSize: number;
}

/**
 * 苹果会员订阅查询参数
 */
export interface AppleSubscribeQueryParams {
  createTimeStart?: number;
  createTimeEnd?: number;
  status?: number;
  transactionId?: string;
  suppId?: number;
  renewalStatus?: number; // 是否续订：1-是，0-否
  /** 通知类型（苹果 NotificationTypeV2 字符串枚举：DID_RENEW / SUBSCRIBED 等） */
  notificationType?: string;
  currentPage: number;
  pageSize: number;
}

/**
 * 苹果会员订阅记录
 */
export interface AppleSubscribeRecord {
  transactionId: string;
  startTime: Record<string, unknown> | string;
  expireTime: Record<string, unknown> | string;
  amount: number;
  suppId: number;
  username: string;
  currency: string; // 币种
  sourceType: number;
  registerTime?: Record<string, unknown> | string; // 注册时间
  periodType: number; // 0-monthly包月，1-yearly半年
  level: number; // 0-标准，1-专业
  productId?: string; // 商品id（苹果列表展示用）
  status: number; // 1-有效，2-过期，3-撤销
  remainingDays: number;
  renewalStatus: number; // 0-否，1-是
  notificationType?: string; // 通知类型（苹果、安卓均有）
  afSource?: string; // appsflyer渠道来源
  afCampaign?: string; // appsflyer归因数据
  deviceType?: number; // 注册端(user_info.device_type)：1-iOS App，2-Android App，3-iOS H5，4-Android H5，5-PC Web
}

/**
 * 安卓会员订阅查询参数
 */
export interface GoogleSubscribeQueryParams {
  createTimeStart?: number; // 查询起始时间（epoch 毫秒）
  createTimeEnd?: number; // 查询结束时间（epoch 毫秒）
  orderId?: string; // 交易ID
  suppId?: number; // 用户SUPP ID
  env?: number; // 订单环境：1-正式，0-测试
  status?: number; // 会员状态：1-有效，2-过期
  renewalStatus?: number; // 是否续订：1-是，0-否
  notificationType?: number; // 通知类型（1-13）
  currentPage: number; // 当前页
  pageSize: number; // 每页数量
}

/**
 * 安卓会员订阅记录
 */
export interface GoogleSubscribeRecord {
  id: number;
  userId: number;
  userName: string;
  suppId: string;
  orderId: string; // 交易ID
  productId: string; // 产品ID
  amount: number; // 金额
  purchaseToken: string; // 解析token
  deleteStatus: number;
  createTime: Record<string, unknown> | string;
  updateTime: Record<string, unknown> | string;
  startTime: Record<string, unknown> | string;
  expireTime: Record<string, unknown> | string;
  autoRenewing: number; // 是否自动续费（0-否，1-是）
  status: number; // PAID(1), PAYMENT_FAILED(2), REQUEST_REFUND(3), REFUNDED(4), REFUND_FAILED(5), EXPIRED(6), REVOKED(7)
  remainingDays?: number; // 剩余天数
  notificationType: string | number; // 通知类型
  registerTime?: Record<string, unknown> | string; // 注册时间
  currency?: string; // 币种
  sourceType?: number;
  afSource?: string; // appsflyer渠道来源
  afCampaign?: string; // appsflyer归因数据
  deviceType?: number; // 注册端(user_info.device_type)：1-iOS App，2-Android App，3-iOS H5，4-Android H5，5-PC Web
  regionCode?: string; // 地区码
}
